import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Element } from "react-scroll";
import { Link } from "react-router-dom";
import "./Home.css"; // You can reuse same CSS

function Blog() {
  return (
    <div>
      {/* Blog Section */}
      <Element
        name="blogs"
        className="section bg-light text-dark py-5 bg-dark"
        style={{ minHeight: "100vh" }}
      >
        <Container className="text-center">
          <h1 className="fw-bold mb-5 text-light">My Blogs ✍️</h1>
          <Row className="g-4 justify-content-center">
            
            {/* Blog Card 1 */}
            <Col xs={12} md={6} lg={4}>
              <Card className="h-100 shadow-sm">
                <Card.Body>
                  <Card.Title className="fw-bold">Python 101 Refresher</Card.Title>
                  <Card.Text>
                    A beginner-friendly refresher on Python basics — data types,
                    operators, loops, and more. Perfect if you’ve been away from coding.
                  </Card.Text>
                  <a
                    href="https://smooth-dragonfly-c0e.notion.site/Python-101-26b7f74da19280a58ca8cabc23f4bd94"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button variant="warning">Read Blog</Button>
                  </a>
                </Card.Body>
              </Card>
            </Col>

            {/* Blog Card 2 - Placeholder */}
            <Col xs={12} md={6} lg={4}>
              <Card className="h-100 shadow-sm">
                <Card.Body>
                  <Card.Title className="fw-bold">Coming Soon 🚀</Card.Title>
                  <Card.Text>
                    More blogs on software engineering, fullstack projects,
                    and my coding journey.
                  </Card.Text>
                  <Button variant="secondary" disabled>
                    Stay Tuned
                  </Button>
                </Card.Body>
              </Card>
            </Col>

          </Row>
        </Container>
      </Element>
    </div>
  );
}

export default Blog;
